module.exports = __webpack_public_path__ + "static/img/2.93861918.jpg";